'use strict'

var merge = require('./lib/util/merge')
var xlink = require('./lib/xlink')
var xml = require('./lib/xml')
var xmlns = require('./lib/xmlns')
var aria = require('./lib/aria')
var html = require('./lib/html')

module.exports = merge([xml, xlink, xmlns, aria, html])



//////////////////
// WEBPACK FOOTER
// ./~/hastscript/~/property-information/html.js
// module id = 197
// module chunks = 35783957827783 204390864267482 254791781388126